import { Component } from '@angular/core';

export class IconSocialFooter {
  link : string;
  src : string;
  alt : string;
  title : string;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  constructor(){}

  socialItem : Array<IconSocialFooter> = [
    {
      link :'https://www.telegram.me/IRani_Expert',
      alt :'تلگرام ایرانی اکسپرت',
      src :'assets/img/01.webp',
      title :'Telegram-Logo',
    },
    {
      link :'https://www.linkedin.com/in/irani-expert-5b7600239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
      alt :'لینکدین ایرانی اکسپرت',
      src :'assets/img/02.webp',
      title :'LinkedIn-Logo',
    },
    {
      link :'https://www.facebook.com/iraniexpert',
      alt :'فیس بوک ایرانی اکسپرت',
      src :'assets/img/03.webp',
      title :'Facebook-Logo',
    },
    {
      link :'https://twitter.com/IRaniExpert',
      alt :'صفحه ایکس ایرانی اکسپرت',
      src :'assets/img/04.webp',
      title :'X(Twitter)-Logo',
    },
    {
      link :'https://www.instagram.com/IRani_Expert/',
      alt :'اینستاگرام ایرانی اکسپرت',
      src :'assets/img/05.webp',
      title :'Instagram-Logo',
    },

  ];

  linksItem = [
    {
      name : 'ربات تریدر اتوماتیک ATM',
      link : 'shop/atm-expert',
    },
    {
      name : 'ربات پاس چالش پراپ PropeX',
      link : 'shop/propex-expert',
    },
    {
      name : 'تقویم اقتصادی لحظه ای',
      link : 'economic-calendar',
    },
    {
      name : 'با ما در تماس باشید',
      link : 'contact-us',
    },
    {
      name : 'چرا ایرانی اکسپرت',
      link : 'about-us',
    },

  ]
}
